<ng-content></ng-content>
<ng-container *ngIf="nzAutoGenerate">
  <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs">
    <a [attr.href]="breadcrumb.url" (click)="navigate(breadcrumb.url, $event)">{{ breadcrumb.label }}</a>
  </nz-breadcrumb-item>
</ng-container>